import { MOBILE_CUTOFF } from "lib/constants";

let parentWindowWidth = null;
let parentWindowHeight = null;

const updateParentWindowSize = (width, height) => {
  parentWindowWidth = width;
  parentWindowHeight = height;
};

const getParentWindowWidth = () => {
  return parentWindowWidth ||
    window.innerWidth;
}

const getParentWindowHeight = () => {
  return parentWindowHeight ||
    window.innerHeight;
}

const isMobileWidth = () => {
  return getParentWindowWidth() <= MOBILE_CUTOFF;
}

export { getParentWindowWidth, getParentWindowHeight, isMobileWidth, updateParentWindowSize };

